import { all, put, takeLatest } from 'redux-saga/effects';
import { resolved } from 'store/createAction';
import { ADD_TO_GROUP, REMOVE_FROM_GROUP } from 'store/modules/contacts/types';
import { REMOVE_MEMBERS, ADD_CONTACTS_TO_GROUP, GET_GROUPS } from './types';
import { getGroupMembersCount } from './actions';

function* getGroupContactCounts({ meta }) {
  // let groupHash;
  // if (meta.groupHash) {
  //   groupHash = meta.groupHash;
  // } else {
  //   groupHash = toIdHash(meta.groupId);
  // }
  yield put(getGroupMembersCount([meta.groupHash]));
}

function* addContactsToGroup({ meta }) {
  yield put(getGroupMembersCount(meta.groupsHash));
}

function* getGroupMembersCountSaga({ payload }) {
  yield put(getGroupMembersCount(payload.map((i) => i.hash)));
}

export default function* root() {
  yield all([
    // takeLatest(resolved(ADD_TO_GROUP), getGroupContactCounts),
    // takeLatest(resolved(REMOVE_FROM_GROUP), getGroupContactCounts),
    // takeLatest(resolved(REMOVE_MEMBERS), getGroupContactCounts),
    takeLatest(resolved(ADD_CONTACTS_TO_GROUP), addContactsToGroup),
    takeLatest(resolved(GET_GROUPS), getGroupMembersCountSaga),
  ]);
}
